import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Select from 'react-select';
import moment from 'moment';
import NumericInput from 'react-numeric-input';
import config from '../../../config';

import {
    getCars,
} from '../../../actions/cars_actions';
import {
    setRecordToOneFuelRecord,
} from '../../../actions/fuel_records_actions';
import {
    updateInputFuelRecord,
    updateInputBillPhotoURL,
    submitFuelRecord,
    clearOneFuelRecord,
    updateFuelRecord,
} from '../../../actions/one_fuel_record_actions';

class EditFuelRecord extends Component {
    constructor(props) {
        super(props);

        this.state = {
            loaded: true,
            errors: [],
        };

        this.handleInput = this.handleInput.bind(this);
        this.handleNumericInputSum = this.handleNumericInputSum.bind(this);
        this.handleImageChange = this.handleImageChange.bind(this);
        this.removeBillPhoto = this.removeBillPhoto.bind(this);
        this.submitRecord = this.submitRecord.bind(this);
    }

    componentDidMount() {
        this.props.getCars();
        this.props.clearOneFuelRecord();
        if(this.props.editRecord)
            this.props.setRecordToOneFuelRecord(this.props.editRecord);
    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            loaded: true,
        });

        if(nextProps.editRecord !== this.props.editRecord)
            this.props.setRecordToOneFuelRecord(nextProps.editRecord);
    }

    handleInput(event) {
        const name = event.target.name;
        const data = event.target.value;
        this.props.updateInputFuelRecord(data, name);
    }

    handleNumericInputSum(valueAsNumber) {
        this.props.updateInputFuelRecord(valueAsNumber, 'sum');
    }

    handleSelectInput(name, event) {
        const data = event.value;

        this.props.updateInputFuelRecord(data, name);
    }

    handleImageChange(event) {
        event.preventDefault();

        const reader = new FileReader();
        const file = event.target.files[0];

        let extension;
        switch (file.type) {
            case "image/png":
                extension = "png";
                break;
            case "image/jpeg":
                extension = "jpg";
                break;
            case "image/gif":
                extension = "gif";
                break;
            default:
                this.setState({
                    errors: [ { "message": "Obrázok môže byť iba png / jpeg / gif." } ]
                });

                setTimeout(() => {
                    console.log("timeout");
                    this.setState({errors: []})
                }, config.errorTimeout);
                return;
        }

        reader.onloadend = () => {
            this.props.updateInputBillPhotoURL(reader.result);
        };

        reader.readAsDataURL(file);
    }

    removeBillPhoto() {
        this.props.updateInputBillPhotoURL(null);
    }

    submitRecord(event) {
        const record = this.props.oneFuelRecord;
        const { carKey, sum, billPhotoURL, type, km } = record;
        const array = [
            carKey,
            sum,
            billPhotoURL,
            type,
            km,
        ];

        let errors = [];
        const errorMessages = [
            'Vyber auto!',
            'Zapíš sumu!',
            'Najhraj obrázok bločku!',
            'Zadaj typ paliva!',
            'Zadaj kilometre!',
        ];

        const valid = array.every((data, index) => {
            let valid = true;

            if(data === null || data === '' || data === undefined) {
                valid = false;
                errors.push({
                    message: errorMessages[index]
                });
            }

            if(index === 1)
                if(isNaN(data)) {
                    valid = false;
                    errors.push({
                        message: "Suma nie je číslo!"
                    });
                }

            if(index === 4)
                if(isNaN(data)) {
                    valid = false;
                    errors.push({
                        message: "KM nie je číslo!"
                    });
                }

            return valid;
        });

        this.setState({
            errors,
        });

        const button = event.target;
        setTimeout(() => {
            button.className = 'btn btn-lg btn-primary';
        }, config.buttonTimeout);

        if(!valid) {
            button.className = 'btn btn-lg btn-danger';

            return;
        }

        if(this.props.editRecord)
            this.props.updateFuelRecord(record);
        else
            this.props.submitFuelRecord(record);

        if(this.props.afterSubmit)
            this.props.afterSubmit();
    }

    alertTimeout() {
        if (this.state.errors.length > 0)
            setTimeout(() => {
                this.setState({errors: []})
            }, config.errorTimeout);
    }

    render() {
        const record = this.props.oneFuelRecord;

        if(!this.state.loaded)
            return <div className="alert alert-info">Načítam...</div>;

        this.alertTimeout();

        return (
            <div className="panel panel-default">
                <div className="panel-heading">
                    <h3 className="panel-title">
                        {this.props.editRecord ? "Úprava záznamu" : "Nový záznam"}
                    </h3></div>
                <div className="panel-body">
                    {(this.state.errors.length > 0) && (
                        <div className="alert alert-danger">{this.state.errors[0].message}</div>
                    )}
                    <div className="table-responsive">
                        <table className="table">
                            <thead>
                            <tr>
                                <th> </th>
                                <th> </th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr>
                                <td>Dátum </td>
                                <td>{moment(record.dateAdd).locale('sk').format('LLL')}</td>
                            </tr>
                            <tr>
                                <td>Auto </td>
                                <td>
                                    <Select
                                        placeholder="Vyber..."
                                        searchable={false}
                                        clearable={false}
                                        value={record.carKey}
                                        options={this.props.cars.map(car => {
                                            return {
                                                label: car.name,
                                                value: car.key
                                            };
                                        })}
                                        onChange={this.handleSelectInput.bind(this, 'carKey')}
                                    />
                                </td>
                            </tr>
                            <tr>
                                <td>Suma </td>
                                <td>
                                    <div className="form-group">
                                        <NumericInput
                                            name="sum"
                                            className="form-control"
                                            step={0.1}
                                            precision={2}
                                            min={0}
                                            max={100}
                                            value={record.sum}
                                            onChange={this.handleNumericInputSum}
                                        />
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td>Bloček </td>
                                {!record.billPhotoURL &&
                                    <td>
                                        <label className="btn btn-default">
                                            Nahrať fotku bločku
                                            <input
                                                type="file"
                                                accept="image/*"
                                                onChange={this.handleImageChange}
                                                style={{display: "none"}}
                                            />
                                        </label>
                                    </td>
                                }
                                {record.billPhotoURL &&
                                    <td>
                                        <div className="col-md-3">
                                            <img
                                                src={record.billPhotoURL}
                                                alt="bill"
                                                className="img-responsiv img-thumbnail"
                                                style={{width: '100%'}}
                                            />
                                        </div>
                                        <div className="col-md-9">
                                            <button
                                                className="btn btn-default"
                                                type="button"
                                                onClick={this.removeBillPhoto}
                                            >
                                                odstrániť obrázok bločku
                                            </button>
                                        </div>
                                    </td>
                                }
                            </tr>
                            <tr>
                                <td>Typ </td>
                                <td>
                                    <Select
                                        placeholder="Vyber..."
                                        searchable={false}
                                        clearable={false}
                                        value={record.type}
                                        options={[
                                            {
                                                value: "LPG",
                                                label: "LPG"
                                            },
                                            {
                                                value: "DIESEL",
                                                label: "DIESEL"
                                            },
                                            {
                                                value: "BENZIN",
                                                label: "BENZIN"
                                            }
                                        ]}
                                        onChange={this.handleSelectInput.bind(this, 'type')}
                                    />
                                </td>
                            </tr>
                            <tr>
                                <td>KM </td>
                                <td>
                                    <div className="form-group">
                                        <input
                                            type="text"
                                            name="km"
                                            className="form-control"
                                            value={record.km}
                                            onChange={this.handleInput}
                                        />
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td colSpan={2}>
                                    <button
                                        className="btn btn-default btn-primary btn-lg"
                                        type="button"
                                        onClick={this.submitRecord}
                                    >
                                        {this.props.editRecord ? "Uložiť" : "Pridať"}
                                    </button>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        );
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        getCars,
        updateInputFuelRecord,
        updateInputBillPhotoURL,
        submitFuelRecord,
        clearOneFuelRecord,
        setRecordToOneFuelRecord,
        updateFuelRecord,
    }, dispatch);
}

function mapStateToProps({ cars, oneFuelRecord }) {
    return { cars, oneFuelRecord };
}

export default connect(mapStateToProps, mapDispatchToProps)(EditFuelRecord);


// WEBPACK FOOTER //
// ./src/app/components/fuelTracker/sub/editFuelRecord.jsx